import { withValidationBluePrint } from '@abp/ng.theme.shared';

export const VALIDATION_BLUEPRINT_PROVIDER = withValidationBluePrint({
  wrongPassword: 'Validations::WrongPassword',
  nameNotUnique: 'Validations::NameNotUnique',
  phoneNumberHintInvalid: 'Validations::PhoneNumberHintInvalid',
  emailInvalid: '::InvalidEmail',
  birthDateInvalid: 'Contact::InvalidBirthDateFormat',
  birthDateAfterCreation: 'Contact::BirthDateCannotBeAfterCreation',
  webRtcHostNotUnique: 'FreeswitchIntegration::WebRtcHostAlreadyInUse',
});
